// getCSRFtoken.js

export default function getCSRFtoken() {
    const cookieValue = document.cookie
        .split('; ')
        .find((row) => row.startsWith('csrftoken='));
    if (cookieValue) {
        return cookieValue.split('=')[1];
    } else {
        console.error('CSRF token not found in cookies.');
        return null;
    }
}
